import { useLocalSearchParams } from 'expo-router';
import { GroupDetailView } from '../../../../../components/worldcup/GroupDetailView/GroupDetailView';

export default function CompetitionGroupDetailScreen() {
  const { groupId } = useLocalSearchParams<{ groupId: string }>();
  return <GroupDetailView groupId={groupId ?? ''} />;
}
